exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pointer[data-v-77141278] {\n  cursor: pointer;\n}", ""]);

